import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksServices: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICES,
	},
	getOrderGeneratorsFieldsWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
	},
	createOrderGeneratorsFieldsWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
	},
	putOrderGeneratorsFieldsWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PUT_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
	},
	patchOrderGeneratorsFieldsWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
	},
	deleteOrderGeneratorsFieldsWorksService: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE,
	},
}
